
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fansinvest/[slug]",
      function () {
        return require("private-next-pages/fansinvest/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fansinvest/[slug]"])
      });
    }
  